import { GetterTree } from 'vuex';
import { AuthState, RootState } from '@/store/types';
import { Sex, UserType, UserTypes } from '@/types/abstract';

const getters: GetterTree<AuthState, RootState> = {
    isAuthenticated(state) {
        return !!state.uid
    },
    getUid(state): string {
        return state.uid;
    },
    getUserType(state): UserType {
        return state.userType;
    },
    getUserSex(state): Sex {
        return state.sex;
    },
    isCast(state): boolean {
        return state.userType == UserTypes.Cast;
    },
    isGuest(state): boolean {
        return state.userType == UserTypes.Guest;
    }
};

export default getters;